export default __webpack_public_path__ + "static/media/sprite.5b34f259.svg";